import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[libPositiveIntegerInput]',
})
export class PositiveIntegerInputDirective {

  constructor(private control: NgControl) { }

   // Listen to the 'input' event to modify user input
   @HostListener('input', ['$event'])
   onInputChange(event: Event): void {
     const inputElement = event.target as HTMLInputElement;
     let value = inputElement.value;
 
    // Remove any non-numeric characters or numbers less than 1
      value = value.replace(/[^0-9]/g, '');
      let numericValue: number | null = null;
      if (value !== '') {
        const parsed = parseInt(value, 10);
        if (parsed >= 1) {
          numericValue = parsed;
        }
      }
      // Set the cleaned value back to input as a string
      inputElement.value = numericValue !== null ? numericValue.toString() : '';
      // Set the control value as a number (or null)
      this.control.control?.setValue(numericValue);
   }
 
   @HostListener('keypress', ['$event'])
   onKeyPress(event: KeyboardEvent): void {
     const char = event.key;
 
     // Disallow characters other than 1-9 or further integers
     if (!/[1-9]/.test(char) && !/\d/.test(char)) {
       event.preventDefault();
     }
   }
}
